<template>
  <div>
    <div class="columns">
      <div class="column is-one-fifth">
        <p class="has-text-weight-bold is-size-6 mb-sm">Webhook Validation</p>
        <p class="has-text-grey is-size-7">
          Generate a webhook secret to validate requests from the
          {{ app.platform }} platform.
        </p>
      </div>
      <div class="column">
        <div class="has-background-white rounded-lg">
          <div class="px-lg">
            <!-- Secret exists? -->
            <div v-if="!loading && secret">
              <div class="py-md">
                <div class="columns is-vcentered is-size-7">
                  <div class="column">
                    <p class="has-text-weight-bold">Webhook Secret</p>
                    <b-field>
                      <b-input
                        v-model="secret"
                        readonly
                        type="password"
                        placeholder="Webhook Secret"
                        password-reveal
                        size="is-medium"
                      ></b-input>
                    </b-field>
                    <p class="has-text-grey">
                      Use this secret to validate incoming webhook requests.
                    </p>
                  </div>
                  <div class="column is-narrow">
                    <span v-clipboard:copy="secret" v-clipboard:success="copied">
                      <b-icon size="is-small" icon="content-copy" />
                    </span>
                  </div>
                </div>
              </div>
              <div class="border-t">
                <div class="columns is-vcentered is-marginless">
                  <div class="column has-text-right">
                    <div class="px-sm">
                      <b-button
                        native-type="submit"
                        type="is-primary rounded-lg"
                        :disabled="loading"
                        @click="showConfirmNewSecret = true"
                      >Generate New Secret</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="!loading && !secret">
              <div class="pa-xxl has-text-centered has-text-grey">
                <p>No webhook secret generated. Click "Generate Secret" below to create one!</p>
              </div>
              <div class="border-t">
                <div class="columns is-vcentered is-marginless">
                  <div class="column has-text-right">
                    <div class="px-sm">
                      <b-button native-type="submit" type="is-primary rounded-lg" :disabled="loading" @click="generateSecret">Generate Secret</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Confirm New Secret Modal -->
     <b-modal :active.sync="showConfirmNewSecret"
      has-modal-card
      :can-cancel="['escape', 'x']">
      <ConfirmNewSecretModal
        @confirm="replaceSecret"
        @cancel="showConfirmNewSecret = false"
      ></ConfirmNewSecretModal>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ConfirmNewSecretModal from './ConfirmNewSecretModal.vue'
export default {
  components: {
    ConfirmNewSecretModal
  },
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return `${this.context.route}/webhooks/webhook-secret/`
    },
    json () {
      const data = {
        replace: this.replace
      }
      return data
    }
  },
  data () {
    return {
      secret: null,
      showSecret: true,
      showConfirmNewSecret: false,
      loading: false,
      replace: false
    }
  },
  methods: {
    generateSecret () {
      this.loading = true
      this.$http.post(this.endpoint, this.json)
        .then(response => {
          this.secret = response.data.webhook_secret
          this.$buefy.toast.open({ type: 'is-success', message: 'Webhook secret generated successfully!' })
          this.replace = false
        })
        .catch(error => {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: error.response.data.detail || 'Failed to generate webhook secret.'
          })
        }).finally(() => {
          this.loading = false
        })
    },
    replaceSecret () {
      this.showConfirmNewSecret = false
      this.replace = true
      this.generateSecret()
    },
    copied () {
      this.$buefy.toast.open({ type: 'is-success', message: 'Copied!' })
    },
    load () {
      if (this.loading) return
      this.loading = true
      this.$http.get(this.endpoint)
        .then(response => {
          this.secret = response.data.webhook_secret
        })
        .catch(error => {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: error.response.data.detail || 'Failed to load webhook secret.'
          })
        }).finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
